/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardComplianceStatus {
    getFixupPrototypeFunction() { return SecurityDashboardComplianceStatus.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardComplianceStatus>): SecurityDashboardComplianceStatus {
        let obj = Object.assign(new SecurityDashboardComplianceStatus(), model);
        SecurityDashboardComplianceStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardComplianceStatus>): SecurityDashboardComplianceStatus {
        if (!model) return null;
        return SecurityDashboardComplianceStatus.newInstance(<SecurityDashboardComplianceStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardComplianceStatus) {
        if (!obj) return;

        models.SecurityDashboardComplianceStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardComplianceStatus): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardComplianceStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_accounts_status) {
            for (let val of this.cloud_accounts_status) {
                models.SecurityDashboardCompliance.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of Compliance
     */
    compliance_name: string;

    /**
     * Security Dashboard Compliance
     */
    cloud_accounts_status: Array<models.SecurityDashboardCompliance>;

}
